export default "./images/survio-38crn-assets-multiple_choice.png";